import {StringLengthRangeConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {Grid} from "@mui/material";
import {t} from "../../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import React from "react";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {NumericField} from "../../../../../../components/fields/textfield/NumericField";


export function StringLengthRangeConstraintPluginForm(props: Readonly<ConstraintPluginProps<StringLengthRangeConstraintDataDto>>) {
    const {data, onChange, errors} = props;

    function updateMin(numValue: number | undefined) {
        onChange({
            ...data,
            min: numValue
        });
    }

    function updateMax(numValue: number | undefined) {
        onChange({
            ...data,
            max: numValue
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <NumericField
                    label={t(DataTypeTranslationKey.MIN_CHARACTERS)}
                    value={data.min}
                    onChange={updateMin}
                    precision={0}
                    errorMessage={errors?.min ? t(errors.min) : undefined}
                    clearable={false}
                    required={true}
                />
            </Grid>
            <Grid item xs={6}>
                <NumericField
                    label={t(DataTypeTranslationKey.MAX_CHARACTERS)}
                    value={data.max}
                    onChange={updateMax}
                    precision={0}
                    errorMessage={errors?.max ? t(errors.max) : undefined}
                    clearable={true}
                />
            </Grid>
        </Grid>
    );

}
